import * as __mod_react from "react";
import * as __mod_react_dom from "react-dom";
import * as __mod_jsx from "react/jsx-runtime";
import * as __mod_rrd from "react-router-dom";
var require = (m) => {
  var __mods = {
    "react": __mod_react,
    "react-dom": __mod_react_dom,
    "react/jsx-runtime": __mod_jsx,
    "react-router-dom": __mod_rrd,
  };
  if (__mods[m]) return __mods[m];
  throw new Error("Cannot require " + m);
};
import{jsx as d}from"react/jsx-runtime";function e({className:t,width:a=120,height:o=40,"data-id":c}){return d("img",{src:"https://cdn.magicpatterns.com/design-systems/ds-bf50d2ed-a1c3-4aac-be2b-c8a50c6202d6/logos/5f4f566c-45fc-49bb-9897-b21d9ed7f009.png",alt:"Logo",className:t,style:{width:a,height:o,objectFit:"contain"},"data-id":c})}export{e as Logo};
//# sourceMappingURL=index.js.map
